<template>
  <div>
    <Headtop/>
    <div class="container">
      <TabCol :ontype="0"/>
      <el-button type="primary" style="float: right;margin: 20px;" icon="el-icon-d-arrow-left" size="medium" @click="goBack">返 回</el-button>
      <div class="main">
        <div class="jobheader flex-y-center">
          <h1>
            <s-dict :value="record.department" code="department"/>
<!--            <span>-</span>-->
<!--            <s-dict :value="record.positionType" code="post_type"/>-->
          </h1>
        </div>
        <el-row class="job-item">
          <el-col class="colitem" :span="24">
            <span class="title">专业要求:</span>
            <span class="ds">
               <s-dict :value="record.professional" code="major_type"/>
            </span>
          </el-col>
          <el-col class="colitem" :span="6">
            <span class="title">发布时间：</span>
            <span class="ds">{{ record.releaseTime}}</span>
          </el-col>
          <el-col class="colitem" :span="9">
            <span class="title">报名申请截止时间：</span>
            <span class="ds">{{ record.deadline}}</span>
          </el-col>
          <el-col class="colitem" :span="9">
              <span class="title">确认笔试截止时间：</span>
              <span class="ds">{{ record.writtenTime}}</span>
          </el-col>
          <el-col class="colitem" :span="6">
            <span class="title">职位类型：</span>
            <span class="ds">
              <s-dict :value="record.positionType" code="post_type"/>
            </span>
          </el-col>
          <el-col class="colitem" :span="6">
            <span class="title">年龄要求：</span>
            <span class="ds">{{record.age}}</span><span>周岁及以下</span>
          </el-col>
          <el-col class="colitem" :span="6">
            <span class="title">性别要求：</span>
            <span class="ds">
            <s-dict :value="record.sex" code="sex"/>
            </span>
          </el-col>
          <el-col class="colitem" :span="6">
            <span class="title">职称要求：</span>
            <span class="ds">
            <s-dict :value="record.job" code="job"/>
            </span>
          </el-col>
          <el-col class="colitem" :span="6">
            <span class="title">招聘人数：</span>
            <span class="ds">{{ record.recruits }}</span>
          </el-col>
          <el-col class="colitem" :span="6">
            <span class="title">考试类别：</span>
            <span class="ds">
             <s-dict :value="record.category" code="category"/>
            </span>
          </el-col>
          <el-col class="colitem" :span="6">
            <span class="title">政治面貌：</span>
            <span class="ds">
              <s-dict :value="record.political" code="political"/>
            </span>
          </el-col>
        </el-row>
        <el-row class="job-item">
          <el-col :span="24">
            <span class="h3">应聘条件</span>
          </el-col>
          <el-col class="job-cont" :span="24">
            <div v-html="record.request"></div>
          </el-col>
        </el-row>
        <el-row class="job-item">
          <el-col :span="24">
            <span class="h3">应聘办法</span>
          </el-col>
          <el-col class="job-cont" :span="24">
<!--            {{ record.method }}-->
            <div v-html="record.method"></div>
          </el-col>
        </el-row>
        <el-row class="job-item">
          <el-col :span="24">
            <span class="h3">招聘程序</span>
          </el-col>
          <el-col class="job-cont" :span="24">
<!--            {{ record.program }}-->
            <div v-html="record.program"></div>
          </el-col>
        </el-row>
        <div class="flex-center jop-foot">
          <el-button @click="applyClick">
            <i class="el-icon-edit-outline"></i>
            申请
          </el-button>
          <el-button class="collect" @click="collectClick">
            <i :class="iscollect == 1 ? 'el-icon-star-on' : 'el-icon-star-off'"></i>收藏
          </el-button>
        </div>
      </div>
    </div>
    <UploadPhotoid ref="UploadPhotopop"/>
  </div>
</template>

<script>
import TabCol from "@/components/TabCol";
import UploadPhotoid from "@/components/UploadPhotoid";
import {getAction,postAction} from "@/api/manage";
import Vue from "vue";
import {SEEKER_INFO} from "@/store/mutation-types"

export default {
  components: {
    TabCol,
    UploadPhotoid
  },
  data() {
    return {
      id: null,
      seeker: {},
      record: {},
      resumeId: null,  //简历ID
      iscollect: false,
      multipleSelection: [], //选择的列表数据
      url:{
         homeDetail: 'home/detail',
         seekerPositionAdd: 'home/seekerPositionAdd',
         isApply:'home/isApply',
         getResumeId: '/resume/experience/getResumeId',
      }
    }
  },
  created() {
    this.id = this.$route.params.id
    this.initDetail()
    this.seeker = Vue.ls.get(SEEKER_INFO)
    this.getResumeId()
  },
  methods: {
    goBack(){
      this.$router.push({name: "Home"});
    },
    initDetail() {
      let _this = this
      if (_this.id === undefined) {
        _this.$router.go(-1)
      } else {
        getAction(_this.url.homeDetail, {id: _this.id}).then(res => {
          if (res.success) {
            _this.$nextTick(() => {
              _this.record = res.result
            })
          }
        })
      }
    },
    //获取简历ID
    getResumeId () {
      let that = this
      let seekerId = that.seeker.id
      getAction (that.url.getResumeId, {seekerId: seekerId}).then((res) => {
        if (res.success) {
          that.resumeId = res.result
        }
      })
    },
    applyClick() {
      //未登录申请直接跳转到登录页面
      if (this.seeker === null) {
        this.$message.error("请先登录在进行申请！")
        this.$router.push({name: "Register"})
        return
      }
      //简历为空跳转到简历页面，否则打开证件设置
      if (this.resumeId === null) {
        this.$router.push({name: "Resume"})
        this.$message.error("请先填写简历")
        return
      }
      //type：1申请 2收藏
      getAction(this.url.isApply,{positionId: this.record.id, seekerId: this.seeker.id, type: 1}).then((res) =>{
        if (res.success) {
          if (res.result) {
             if (this.record.isUpload === 1) {
              this.$refs.UploadPhotopop.open(this.id)
            } else {
              this.onSubmit(1)
            }
          } else {
            this.$message({type: "warning", message: "您已经申请过了"})
          }
        } else {
          this.$message({type: "error", message: res.message})
        }
      })
    },
    onSubmit(type) {
      let that = this
      postAction(that.url.seekerPositionAdd, {"positionIds": that.record.id, "seekerId" : that.seeker.id, "type": type}).then((res) => {
        if (res.success) {
          this.$message({type: "success", message: "操作成功，请在'我的申请'里面提交申请！"})
        } else {
          this.$message({type: "error", message: res.message})
        }
      }).finally(() => {
      });
    },
    collectClick() {
      if (this.iscollect == 1) {
          this.iscollect = 0
      } else {
          this.iscollect = 1
      }
      this.onSubmit(2)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    // 选择的列表数据
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
  }
}
</script>

<style lang="less" scoped>
.main {
  background-color: #f4f4f4;
}

.jobheader {
  height: 84px;
  //
  padding: 0px 46px;

  h1 {
    font-size: 18px;
    color: #3466cc;
    position: relative;
    display: inline-block;

    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -10px;
      transform: translate(-50%, 0);
      width: 80%;
      height: 4px;
      background-color: #3466cc;
    }
  }
}

.job-item {
  border-top: dashed 1px #3466cc;
  padding: 0px 46px;
  padding-bottom: 22px;
}

.colitem {
  margin-top: 24px;
  font-weight: bold;

  .title {
    color: #3466cc;
    font-size: 16px;
    margin-right: 10px;
  }

  .ds {
    font-size: 16px;
    color: #666;
  }
}

.h3 {
  font-size: 18px;
  color: #3466cc;
  position: relative;
  font-weight: bold;
  display: inline-block;
  margin: 24px 0px;

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -10px;
    transform: translate(-50%, 0);
    width: 80%;
    height: 4px;
    background-color: #3466cc;
  }
}

.job-cont {
  padding-left: 72px;

  p {
    text-indent: 20px;
    color: #aaaaaa;
    font-size: 16px;
    line-height: 30px;
  }
}

.jop-foot {
  padding: 0px 20px;
  background-color: #d3e0fd;
  width: 100%;
  height: 58px;

  .el-button {
    width: 56px;
    height: 28px;
    background-color: #fc9a26;
    border-radius: 7px;
    text-align: center;
    padding: 0px;
    line-height: 28px;
    color: #fff;
    margin-left: 18px;
  }

  .collect {
    background-color: #3466cc;
  }
}
</style>
